<!--<c-footer>-->
<div>
  <!-- <a href="#" target="_blank">SV</a>
  <span> &copy; 2022 SV Infotech</span> -->
</div>
<div class="ms-auto">
  Powered by
  <a href="#" target="_blank">
    <span> SV Infotech</span>
  </a>
</div>
<!--</c-footer>-->